import { render, staticRenderFns } from "./CreateMasterActiveCourse.vue?vue&type=template&id=abf26ffc"
import script from "./CreateMasterActiveCourse.vue?vue&type=script&lang=js"
export * from "./CreateMasterActiveCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports